import { AdminManageGetNotificationsGet$Params } from '../../generated/auth/fn/admin/admin-manage-get-notifications-get';
import { Notification } from '../../generated/auth/models/Wealth/Online/Shared/Data/Models/notification';

export const DefaultFilterState: AdminManageGetNotificationsGet$Params = {
  Type: undefined,
  Status: undefined,
  CrmNumber: undefined,
  DateFrom: undefined,
  DateTo: undefined,
  Search: undefined,
  SortBy: undefined,
  SortDescending: undefined,
  Page: 1,
  PageSize: 10,
};

export interface PaginationInfo {
  currentPage: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

export interface ExternalNotificationState {
  notifications?: Notification[];
  filter?: AdminManageGetNotificationsGet$Params;
  loading?: boolean;
  error?: any;
  isFilterOpen?: boolean;
  pagination?: PaginationInfo;
}

export const initialExternalNotificationState: ExternalNotificationState = {
  notifications: [],
  filter: DefaultFilterState,
  loading: false,
  error: null,
  isFilterOpen: false,
  pagination: {
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
    totalPages: 0,
  },
};
